import { RequestSender } from "./helpers";

type UpdateShippingAddressInput = {
  readonly line1: string;
  readonly line2?: string;
  readonly city: string;
  readonly state: string;
  readonly postalCode: string;
  readonly country: string;
};

async function updateShippingAddress(
  request: RequestSender,
  input: UpdateShippingAddressInput,
): Promise<{ updatedOrders: number }> {
  const response = await request("put", "/profile/shipping-address", input);
  return response.data.data as { updatedOrders: number };
}

export type { UpdateShippingAddressInput };
export default updateShippingAddress;
